import React, { useState } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';

export default function TipContext(props: any) {
  let { type, style, className, selected = false } = props;
  // type 要传入对象一个是默认， 一个是hover之后  ， 不传入按提示的展示
  const [isIconHover, setIsIconHover] = useState(false);

  return (
    <div
      onMouseOver={() => {
        setIsIconHover(true);
      }}
      onMouseOut={() => {
        setIsIconHover(false);
      }}
      style={style}
      className={`db-tipcontext-icon ${className ? className : ''}`}
    >
      <div className="db-tipcontext-box">
        {selected ? (
          <SvgIcon
            className="db-tipcontext-selected"
            type={
              isIconHover
                ? type?.hover
                  ? type.hover
                  : 'action-tab-icon'
                : type?.default
                ? type.default
                : 'tab-tip-icon'
            }
          />
        ) : (
          <SvgIcon
            type={
              isIconHover
                ? type?.hover
                  ? type.hover
                  : 'alert-circle-action'
                : type?.default
                ? type.default
                : 'alert-circle-m'
            }
          />
        )}
      </div>
    </div>
  );
}
